import React from 'react';
// import Header from '../Partial/header/header';
import Footer from '../Partial/footer/footer';
import Navbar from '../Partial/navbar/Navbar';

import PhotoSlider from './photoSlider';
import IntroAbout from './introAbout';
import OurAbility from './ourAbility';

export default function aboutUs(){
    return(
        <div>
            {/* <Header/> */}
            <Navbar/>
            <PhotoSlider/>
            <OurAbility/>
            <IntroAbout/>
            <Footer/>
        </div>
    )
}